function enableZoom(img) {
    if (img.dataset.zoomAttached) return;
    img.dataset.zoomAttached = true;

    const zoomLevel = 2;

    // ==============================
    // DESKTOP VERSION
    // ==============================
    if (window.innerWidth > 768) {

        let zoomBox = document.createElement("div");
        zoomBox.className = "custom-zoom-box";
        document.body.appendChild(zoomBox);

        zoomBox.style.backgroundImage = `url(${img.currentSrc || img.src})`;
        zoomBox.style.backgroundRepeat = "no-repeat";
        zoomBox.style.display = "none";
        zoomBox.style.position = "fixed";
        zoomBox.style.width = "500px";
        zoomBox.style.height = "500px";
        zoomBox.style.top = "50%";
        zoomBox.style.left = "50%";
        zoomBox.style.transform = "translate(-50%, -50%)";
        zoomBox.style.zIndex = "9999";

        img.addEventListener("mouseenter", function () {
            zoomBox.style.display = "block";
        });

        img.addEventListener("mousemove", function (e) {
            const rect = img.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            if (x < 0 || y < 0 || x > rect.width || y > rect.height) return;

            const bgX = -(x * zoomLevel - zoomBox.offsetWidth / 2);
            const bgY = -(y * zoomLevel - zoomBox.offsetHeight / 2);

            zoomBox.style.backgroundPosition = `${bgX}px ${bgY}px`;
            zoomBox.style.backgroundSize =
                img.width * zoomLevel + "px " + img.height * zoomLevel + "px";
        });

        img.addEventListener("mouseleave", function () {
            zoomBox.style.display = "none";
        });
    }

    // ==============================
    // MOBILE VERSION (Tap Zoom)
    // ==============================
    else {

        img.addEventListener("click", function () {

            let overlay = document.createElement("div");
            overlay.className = "mobile-zoom-overlay";

            let zoomedImg = document.createElement("img");
            zoomedImg.src = img.currentSrc || img.src;

            overlay.appendChild(zoomedImg);
            document.body.appendChild(overlay);

            overlay.addEventListener("click", function () {
                overlay.remove();
            });
        });
    }
}

function initZoom() {
    if (!window.location.pathname.includes("/products/")) return;

    const productImages = document.querySelectorAll(".slide-item img");
    if (!productImages.length) return;

    productImages.forEach((img) => {
        if (img.complete) {
            enableZoom(img);
        } else {
            img.addEventListener("load", () => enableZoom(img));
        }
    });
}

document.addEventListener("DOMContentLoaded", initZoom);
document.addEventListener("shopify:section:load", initZoom);
document.addEventListener("shopify:section:reorder", initZoom);